import ApiConstant from "../../constants/api.constants";
import api from "../api";
import { VendorSummaryDTO, CreateVendorDTO } from "../../models/vendors/vendor-model";

const getAllVendors = async (): Promise<VendorSummaryDTO[]> => {
  try {
        const vendor: any = await api
        .get(ApiConstant.getallvendors)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error reading get vendor details', error);
         });
        const response = vendor != null ? vendor : null;        
        return response;
    }
    catch (e) {
        console.log('error in vendor details');
        return [];
    } 
};

const createVendor = async (data: CreateVendorDTO): Promise<any> => {
  try {
    const response = await api.post(ApiConstant.createVendor, data);
    return response.data;
  } catch (error) {
    console.error("Error creating vendor:", error);
    throw error;
  }
};

const updateVendor = async (data: any): Promise<any> => {
  const res = await api.put(ApiConstant.updateVendor, data); 
  return res.data;
};


const deleteVendor = async (vendorID: number): Promise<any> => {
  return await api.delete(`${ApiConstant.deleteVendor}?vendorID=${vendorID}`);
};

const filterVendors = async (searchQuery: string): Promise<VendorSummaryDTO[]> => {
  try {
    const response = await api.get(ApiConstant.filterVendors, {
      params: { searchQuery }
    });
    return response.data ? response.data : [];
  } catch (error) {
    console.error("Error filtering vendors:", error);
    return [];
  }
};

const vendorService = {
  getAllVendors,
  createVendor,
  updateVendor,
  deleteVendor,
  filterVendors
};

export default vendorService;
